import { useEffect, useState } from "react";
import axios from "axios";
import { ContactItem } from "./ContactItem";

export function Contact() {
    const [contacts, setContacts] = useState([]);

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Contacts`);
                setContacts(response.data);
            } catch (error) {
                console.error("Error fetching contacts:", error);
            }
        };

        fetchContacts();
    }, []);

    return (
        <div className="section bg-dark-pink  row">
            <h6 className="nc-text-secondary text-uppercase">Kontakt</h6>
            <div className="row">
                {contacts.map((contact, index) => (
                    <div className="contactItem" key={index}>
                        <ContactItem contact={contact} />
                    </div>
                ))}
            </div>
        </div>
    );
}